import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import ROUTES from "../config/routes";
import { useAuth } from "../features/auth/context/AuthContext";

export default function AuthGuard({ children }) {
  const location = useLocation();
  const { isAuthenticated, isHydratingAuth } = useAuth();

  if (isHydratingAuth) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.ROOT} replace state={{ from: location }} />;
  }

  return children;
}
